import { Fragment, useContext, useState, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { ReEntryAssessmentResult } from "../../Models/Assessment";
import { ReEntryAssessmentCard } from "../../Assessments/ReEntryAssessmentCard";
import { AuthContext } from "../../../Auth/AuthProvider";
import { abpnClient } from "../../../../Services/AbpnClient";

export function ArticleReentryExaminationCard() {

    const authContext = useContext(AuthContext);
    const [reEntryAssessments, setReEntryAssessments] = useState<Array<ReEntryAssessmentResult>>(null);

    useEffect(()=>{
        abpnClient.get<Array<ReEntryAssessmentResult>>(`/api/physician/GetReEntryAssessments`,authContext)
        .then(_=>{setReEntryAssessments(_.sort((a: ReEntryAssessmentResult, b: ReEntryAssessmentResult)=>{
            return a.endYear - b.endYear;
        }));
        });
    },[]);

    return(
        reEntryAssessments?.length > 0 &&
        <Fragment>
            <Card className="mb-4" border="pp-secondary-grey">
                <Card.Body>
                    <Card.Title className="mb-0 font-weight-bolder">
                        <span className="text-pp-primary">Assessments for Re-Entry</span>
                    </Card.Title>
                    <Row className="mt-3">
                        <Col xs={12} md={12} lg={12} xl={12}>                        
                            <Fragment>
                                
                                    {reEntryAssessments.map((assessment: ReEntryAssessmentResult) => {
                                        return <ReEntryAssessmentCard assessment={assessment} />
                                    })}
                                    
                            </Fragment>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            
        </Fragment>
    );
}